import type { Notification } from '../services/notificationApi';
import { getPropertyDisplayHeading } from './propertyAddress';
import { parseNotificationMetadata } from './contractRequestNotification';

/** Hiện địa chỉ/số phòng trong thông báo thay cho tiêu đề listing. */
export function formatNotificationListingCopy(
  notification: Pick<Notification, 'title' | 'message' | 'metadata' | 'content'>,
): { title: string; message: string } {
  const meta = parseNotificationMetadata(notification) || {};
  const room = typeof meta.room_number === 'string' ? meta.room_number : '';
  const address =
    (typeof meta.full_address === 'string' && meta.full_address) ||
    (typeof meta.property_address === 'string' && meta.property_address) ||
    '';
  const storedTitle =
    (typeof meta.property_title === 'string' && meta.property_title) ||
    '';
  const storedName =
    (typeof meta.property_name === 'string' && meta.property_name) ||
    '';

  let title = notification.title || '';
  let message = notification.message || '';

  if (!room && !address) {
    return { title, message };
  }

  const heading = getPropertyDisplayHeading({
    title: storedTitle,
    room_number: room,
    full_address: address,
  });

  const replacements = [storedTitle, storedName].filter(
    (value) => value.trim() && value.trim() !== heading,
  );

  for (const old of replacements) {
    title = title.split(old).join(heading);
    message = message.split(old).join(heading);
  }

  return { title, message };
}
